// All buildings under Contract TOP-25-27
// Town of Paradise | Fabian Traverse Cleaning

export const BUILDINGS = [
  {
    id: 'A',
    name: 'Town Hall',
    address: '28 McNamara Drive, Paradise NL',
    monthlyRate: 4000,
    status: 'inactive',
    note: 'Inaccessible — fire remediation. Expected September 2026.',
    window: 'Mon–Fri · 5:00pm – 12:00am',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Transport to nearest dumpster site',
  },
  {
    id: 'B',
    name: 'Temporary Town Depot',
    address: '35 Glencoe Drive, Paradise NL',
    monthlyRate: 2300,
    status: 'active',
    window: 'Mon–Fri · 5:00pm – 12:00am',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Dumpster on site at 1655 Topsail Rd',
    note: 'Excluded: Depot garage.',
  },
  {
    id: 'C',
    name: 'Depot Portable Trailer',
    address: '28 McNamara Drive, Paradise NL',
    monthlyRate: 1500,
    status: 'active',
    window: 'Mon–Fri · 5:00pm – 12:00am',
    leed: false,
    restricted: false,
    storage: 'No storage — bring supplies each shift',
    garbageDisposal: 'Transport to nearest dumpster site',
    note: 'No on-site storage. Trailer only.',
  },
  {
    id: 'D',
    name: 'Wastewater Treatment Plant',
    address: '619 St. Thomas Line, Paradise NL',
    monthlyRate: 1700,
    status: 'active',
    // Was listed as a fixed Monday slot, but the Town's actual weekly
    // submissions move this around week to week (see
    // supabase-week-2026-08-17.sql, which has it on Sunday) — same "Per
    // rental schedule" treatment as the other Town-submitted buildings.
    window: 'Per rental schedule · Office & Washroom only',
    leed: false,
    restricted: true,
    storage: 'Building has storage area',
    garbageDisposal: 'Transport to nearest dumpster site',
    note: 'RESTRICTED — Office & Washroom ONLY. No entry to plant areas.',
  },
  {
    id: 'E',
    name: 'Paradise Double Ice Complex',
    address: '1 Sarah Davis Way, Paradise NL',
    monthlyRate: 8300,
    status: 'active',
    window: '7 days · 9:00am – 2:00am · Min. 2 staff',
    leed: true,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Dumpster on site at arena',
    note: 'LEED products required. Min 2 staff at all times.',
  },
  {
    id: 'F',
    name: 'Rotary Paradise Youth & Community Centre',
    address: '1 Sarah Davis Way, Paradise NL',
    monthlyRate: 5550,
    status: 'active',
    window: '7 days · 9:00am – 2:00am · Min. 2 staff',
    leed: true,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Dumpster on site at RPYCC',
    note: 'LEED products required. Shares checklist with Building E.',
    sharedChecklist: 'E',
  },
  {
    id: 'G',
    name: 'Paradise Park Concession Building',
    address: 'Sarah Davis Way, Paradise NL',
    monthlyRate: 900,
    status: 'active',
    window: '7 days · 9:00am – 2:00am (PDIC/RPYCC staff)',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Dumpster on site at arena',
    note: 'Canteen/food prep cleaned by tenant. Change rooms seasonal (Jun 18 – Sep 23).',
  },
  {
    id: 'H',
    name: 'Dianne Whalen Soccer Complex',
    address: 'McNamara Drive, Paradise NL',
    monthlyRate: 1300,
    status: 'active',
    window: 'Per rental schedule · Dec–Apr: 1x/wk · May–Nov: 12x/wk',
    leed: false,
    restricted: false,
    storage: 'No storage — bring supplies each shift',
    garbageDisposal: 'Transport to nearest dumpster site',
    note: 'Rental-based cleaning. Town provides weekly schedule.',
  },
  {
    id: 'I',
    name: 'St. Thomas Community Centre',
    address: '2 Neary Road, Paradise NL',
    monthlyRate: 2000,
    status: 'active',
    window: 'Per rental schedule · ~8x/week year-round',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Dumpster on site at St. Thomas Line',
    note: 'Rental-based cleaning. Town provides weekly schedule.',
  },
  {
    id: 'J',
    name: 'Softball Clubhouse',
    address: 'Milton Road, Paradise NL',
    monthlyRate: 1110,
    status: 'active',
    window: 'Per rental schedule · Oct–May: 4x/wk · Jun–Sep: 12x/wk',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Transport to nearest dumpster site',
    note: 'Min 2 hrs × 2 staff per clean.',
  },
  {
    id: 'K',
    name: 'Peter Barry Duff Memorial Park Building',
    address: '272 Topsail Pond Road, Paradise NL',
    monthlyRate: 750,
    status: 'active',
    window: 'Per rental schedule · Outside WC: twice daily year-round · 9:30pm',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Dumpster on site at Peter Barry Duff',
    note: 'CRITICAL: Outside washrooms 2x daily every day year-round including holidays.',
  },
  {
    id: 'L',
    name: 'St. Thomas Line Pump Station',
    address: '3 St. Thomas Line, Paradise NL',
    monthlyRate: 800,
    status: 'active',
    window: 'Mondays · 8:00am – 11:00am (same run as Building D)',
    leed: false,
    restricted: true,
    storage: 'Building has storage area',
    garbageDisposal: 'Transport to nearest dumpster site',
    note: 'RESTRICTED — Office & Washroom ONLY. Same Monday run as Building D.',
    sharedChecklist: 'D',
  },
  {
    id: 'M',
    name: 'Temp. Engineering & Corporate Services',
    address: '1270 Kenmount Road, Paradise NL',
    monthlyRate: 3000,
    status: 'inactive',
    window: 'Mon–Fri · 5:00pm – 12:00am',
    leed: false,
    restricted: false,
    storage: 'Building has storage area',
    garbageDisposal: 'Rolling garbage cans in entrance',
    note: 'Removed from contract March 31, 2026.',
  },
  {
    id: 'N',
    name: 'Temp. Corporate Services & Planning',
    address: '1655 Topsail Road, Paradise NL',
    monthlyRate: 720,
    status: 'active',
    window: 'Mon–Fri · 5:00pm – 12:00am',
    leed: false,
    restricted: false,
    storage: 'No storage — bring supplies each shift',
    garbageDisposal: 'Dumpster on site at 1655 Topsail Rd',
    note: 'Shares checklist with Building A (Town Hall).',
    sharedChecklist: 'A',
  },
];

export const SPECIAL_EVENTS_ALLOCATION = 600; // hours per contract year
export const SPECIAL_EVENTS_RATE_SHORT = 280; // per 2-4hr event (over 600hrs)
export const SPECIAL_EVENTS_RATE_FULL = 520;  // per full-day event (over 600hrs)

// Contract year runs Apr 1 – Mar 31. Single source of truth so the Special
// Events tracker, invoice generator, etc. all roll the 600hr allocation
// over on the same date instead of drifting apart or never resetting.
export function getContractYearStart(reference = new Date()) {
  const year = reference.getFullYear();
  const month = reference.getMonth(); // 0-indexed; April = 3
  const y = month >= 3 ? year : year - 1;
  return new Date(y, 3, 1);
}

export function getContractYearLabel(reference = new Date()) {
  const startYear = getContractYearStart(reference).getFullYear();
  return `${startYear}/${startYear + 1}`;
}

export const CONTRACT = {
  number: 'TOP-25-27',
  name: 'Provision of Janitorial Services: Town Facilities',
  client: 'Town of Paradise',
  contractor: 'TC Janitorial Inc. (Fabian Traverse Cleaning)',
  monthlyBase: 34680,  // without Town Hall (inactive) and Building M (removed)
  annualBase: 416160,
  paymentTerms: 'Net 30',
  contact: {
    name: 'Jason Lawrence',
    role: 'Day-to-Day Operations Contact',
    email: 'jlawrence@paradise.ca',
    phone: '709-765-7599',
  },
  financial: {
    name: 'Stephen Stockley',
    role: 'Financial / Contract Questions',
  },
};
